import Vue from "vue";

const state = {
    countries: []
}

const getters = {
    countries: state => {
        return state.countries
    },
}

const mutations = {
    setCountries (state, data) {
        Vue.set(state, 'countries', data)
    }
}


export default {
    state,
    getters,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/countries.js